<template lang="pug">
  #customization-navigator
    WtButton(
      isRouterLink
      :to="{ name: 'ProgramSettings' }"
      :color="$route.name === 'ProgramSettings' ? 'primary': 'white'"
      :class="$route.name !== 'ProgramSettings' ? 'inactive-route': null"
    ) Program Settings
    WtButton.ml-4(
      isRouterLink
      :to="{ name: 'ProgramCustomization' }"
      :color="$route.path.includes('/admin/program-center/settings/customization') ? 'primary': 'white'"
      :class="!$route.path.includes('/admin/program-center/settings/customization') ? 'inactive-route': null"
    ) Customization
</template>

<script>
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "ProgramCustomizationNavigator",

  components: { WtButton }
};
</script>

<style lang="sass">
#customization-navigator
  .inactive-route
    color: $grey-light
    border-color: $grey-light
</style>
